/* istanbul ignore file */
import logger from '@adc/logger'
import configment from '@adc/configment'

const CHAT_WINDOW_HEIGHT = 505
const CHAT_WINDOW_WIDTH = 485
const SAFARI_HEIGHT_ADJUSTMENT = 18

function openChatPopup(user) {
  let url =
    (typeof window === 'undefined' ? '' : window.location.origin) + '/apps/chat'
  if (user?.logged_in) {
    url =
      url +
      '?Email=' +
      user.email_address +
      '&FirstName=' +
      user.first_name +
      '&LastName=' +
      user.last_name
  }

  if (typeof window !== 'undefined') {
    const originUrl = window.location.href
    url += user?.logged_in ? '&' : '?'
    url += 'originUrl=' + encodeURIComponent(originUrl)
  }

  popupCenter(url, CHAT_WINDOW_WIDTH, CHAT_WINDOW_HEIGHT)
}

function popupCenter(url, w, h) {
  // Fixes dual-screen position
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : screen.left
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : screen.top
  let width
  let height

  if (window.innerWidth) {
    width = window.innerWidth
  } else {
    width = document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width
  }

  if (window.innerHeight) {
    height = window.innerHeight
  } else {
    height = document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height
  }

  const left = width / 2 - w / 2 + dualScreenLeft
  const top = height / 2 - h / 2 + dualScreenTop

  // safari hack as safari opens windows slightly smaller.
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  const newWindow = window.open(
    url,
    'apps/chat',
    `scrollbars=yes, toolbar=no, titlebar=no, width=${w}, height=${
      h + (isSafari && SAFARI_HEIGHT_ADJUSTMENT)
    }, top=${top}, left=${left}`
  )

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus()
  }
}

export const setUserChatInfo = (firstName = '', lastName = '', email = '') => {
  window?.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields?.({
    First_Name: firstName,
    Last_Name: lastName,
    Email: email,
    URL: window.location.href,
    Browser: window.navigator.userAgent,
  })
}

const initEmbeddedMessaging = onButtonClicked => {
  const salesforceChatConfig = configment.get('SALESFORCE_V2_CHAT', {})
  try {
    window.embeddedservice_bootstrap.settings.language = 'en_US' // For example, enter 'en' or 'en-US'
    window.addEventListener('onEmbeddedMessagingButtonClicked', () => {
      onButtonClicked()
    })
    window.embeddedservice_bootstrap.init(
      salesforceChatConfig.chatId,
      'Auction_Chat_Web',
      salesforceChatConfig.sandboxUrl,
      {
        scrt2URL: salesforceChatConfig.scriptInitUrl,
      }
    )
  } catch (err) {
    logger.error('Error loading Embedded Messaging: ', err)
  }
}

const loadSalesforceV2Chat = onButtonClicked => {
  const salesforceChatConfig = configment.get('SALESFORCE_V2_CHAT', {})
  const script = document.createElement('script')
  script.src = `${salesforceChatConfig.sandboxUrl}/assets/js/bootstrap.min.js`
  script.onload = () => {
    initEmbeddedMessaging(onButtonClicked)
  }
  document.body.appendChild(script)
}

export default {
  openChatPopup,
  loadSalesforceV2Chat,
  setUserChatInfo,
}
